import {useState} from "react";
import {sendSlackMessageTracked} from "../../../models/notifications";
import PropTypes from "prop-types";


export default function EmailBoxCTA(props) {

    const [isExpanded, setIsExpanded] = useState(false);
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [website, setWebsite] = useState('');
    const [didSubmit, setDidSubmit] = useState(false);

    return (
        <div>
            <div className="mx-auto mt-10 flex max-w-md gap-x-4">
                <label htmlFor="email-address" className="sr-only">
                    Email address
                </label>
                <input
                    id="email-address"
                    name="email"
                    type="email"
                    required
                    disabled={didSubmit}
                    placeholder="Enter your email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="bg-gray-50 min-w-0 flex-auto rounded-md px-3.5 py-3.5 text-base text-gray-400 outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 dark:outline-white/20"
                    style={{
                        color: "black"
                    }}
                />

                {
                    !isExpanded && (
                        <button
                            type="submit"
                            className="flex-none rounded-md bg-white/5 ring-1 px-3.5 py-2.5 text-lg font-semibold text-gray-900 shadow-xs hover:bg-gray-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white dark:shadow-none"
                            style={{
                                color: props.textColor
                            }}
                            onClick={() => {
                                sendSlackMessageTracked(`💎 Lead is submitting personal information: \n Name: ${name}\n Email: ${email} \nWebsite ${website}`)
                                setIsExpanded(true)
                            }}
                        >
                            {
                                didSubmit ? "Submitted!" : props.ctaText
                            }
                        </button>
                    )
                }
            </div>

            {
                isExpanded && (
                    <div>

                        <div className="mx-auto mt-4 flex max-w-md gap-x-4">
                            <label htmlFor="email-address" className="sr-only">
                                Email address
                            </label>
                            <input
                                id="full-name"
                                name="name"
                                type="name"
                                disabled={didSubmit}
                                required
                                placeholder="Enter your name"
                                autoComplete="name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="bg-gray-50 min-w-0 flex-auto rounded-md px-3.5 py-3.5 text-base text-gray-400 outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 dark:outline-white/20"
                                style={{
                                    color: "black"
                                }}
                            />
                        </div>

                        <div className="mx-auto mt-4 flex max-w-md gap-x-4">
                            <label htmlFor="email-address" className="sr-only">
                                Email address
                            </label>
                            <input
                                id="website"
                                name="website"
                                disabled={didSubmit}
                                type="url"
                                required
                                placeholder="Enter your website"
                                value={website}
                                onChange={(e) => setWebsite(e.target.value)}
                                className="bg-gray-50 min-w-0 flex-auto rounded-md px-3.5 py-3.5 text-base text-gray-400 outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 dark:outline-white/20"
                                style={{
                                    color: "black"
                                }}
                            />
                        </div>

                        <div className="mx-auto mt-8 flex max-w-md gap-x-4">
                            <button
                                disabled={didSubmit}
                                type="submit"
                                className="bg-green-400 w-full rounded-md bg-white/5 ring-1 px-3.5 py-2.5 text-lg font-semibold text-gray-900 shadow-xs hover:bg-gray-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white dark:shadow-none"
                                style={{
                                    color: props.textColor
                                }}
                                onClick={() => {
                                    sendSlackMessageTracked(`💎 Lead is submitting personal information: \n Name: ${name}\n Email: ${email} \nWebsite ${website}`)
                                    // Displays submit message on button text
                                    setDidSubmit(true)

                                }}
                            >
                                {
                                    didSubmit ? "Submitted!" : props.ctaText
                                }
                            </button>
                        </div>

                    </div>
                )
            }
        </div>
    )
}


EmailBoxCTA.propTypes = {
    textColor: PropTypes.string,  // For CTA button
    ctaText: PropTypes.string,
}

EmailBoxCTA.defaultProps = {
    textColor: "#FFFFFF",  // For CTA button
    ctaText: "Submit",
}